import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

/**
 * A drone manufacturer, as `GET /lookups/drone-manufacturers` returns it (`{ id, name, logoUrl }`).
 * Read-only lookup data for dropdowns (the web never writes it), so `name` falls back to '' for display.
 * Mirrors hub `data-models/drone-manufacturer.ts`.
 */
export class DroneManufacturer extends Base {
  name: string;
  logoUrl?: string;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.name = nullableString(source['name']) ?? '';
    this.logoUrl = nullableString(source['logoUrl']) ?? undefined;
  }
}
